import Axios from "../../utils/axios";
import { authFetch } from "../../utils/authTokenService";

export const readChurches = async (payload) => {
  const response = await Axios.post("/churches/read", payload);
  return response.data;  
};
export const likeChurch = async (payload) => {
  const params = new URLSearchParams();
  if (payload?.churchObjId) params.append("churchObjId", payload.churchObjId);
  if (payload?.channelObjId) params.append("channelObjId", payload.channelObjId);
  if (payload?.ministriesObjId) params.append("ministriesObjId", payload.ministriesObjId);
  if (payload?.homeChurch !== undefined) params.append("homeChurch", payload.homeChurch);
  const body = params.toString();

  const response = await authFetch(`${process.env.REACT_APP_BASE_URL}users/churches/like`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      accept: "application/json",
    },
    body: body,
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || "Failed to like church");
  }

  return await response.json();
};

export const saveServiceVolunteer = async (payload) => {
  const params = new URLSearchParams();
  const language = localStorage.getItem("language_preferred");
  if (payload?._id) params.append("_id", payload._id);
  if (payload?.serviceObjId) params.append("serviceObjId", payload.serviceObjId);
  if (payload?.userAuthId) params.append("userAuthId", payload.userAuthId);
  if (payload?.firstName) params.append("firstName", payload.firstName);
  if (payload?.lastName) params.append("lastName", payload.lastName);
  if (payload?.email) params.append("email", payload.email);
  if (payload?.author) params.append("author", payload.author);
  params.append("mobile", "false");
  params.append("language_code", language || "en");

  const response = await authFetch(
    `${process.env.REACT_APP_BASE_URL}churches/services/volunteers/save`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        accept: "application/json",
      },
      body: params.toString(),
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || "Failed to save service volunteer");
  }

  return await response.json();
};

export const readFeaturedChurches = async (payload) => {
  const response = await Axios.post("/users/featuredchurches", payload);
  return response.data;
};

export const readFavouriteChurches = async (payload) => {
  const response = await Axios.post("/users/favouritechurches", payload);
  return response.data;
};

export const readHomeChurches = async (payload) => {
  const response = await Axios.post(
    "/users/homechurches",
    payload
  );
  return response.data;
};

export const readNearbyChurches = async (payload) => {
  const response = await Axios.post("/users/churchesnearme", payload);
  return response.data;
};


export const unlikeChurch = async (payload) => {
  const params = new URLSearchParams();
  if (payload?.churchObjId) params.append("churchObjId", payload.churchObjId);
  if (payload?.channelObjId) params.append("channelObjId", payload.channelObjId);
  if (payload?.ministriesObjId) params.append("ministriesObjId", payload.ministriesObjId);
  const body = params.toString();

  const response = await authFetch(
    `${process.env.REACT_APP_BASE_URL}users/churches/unlike`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        accept: "application/json",
      },
      body,
    }
  );

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || "Failed to unlike church");
  }

  return await response.json();
};
